<template>
  <div>
    <div v-loading="loading" element-loading-text="Procesando...">
      <form
        @submit.prevent="store('new-inventory')"
        data-vv-scope="new-inventory"
      >
        <div class="row">
          <!-- end col one -->
          <div class="col-md-3">
            <div class="form-group">
              <label>Proveedor</label>
              <el-select
                placeholder=""
                no-data-text="No hay datos."
                no-match-text="No hay resultados."
                v-model="doc.provider"
                value-key="id"
                name="provider"
                v-validate="'required'"
                filterable
                class="form-control"
              >
                <el-option
                  v-for="provider in providers"
                  :key="provider.id"
                  :label="provider.name"
                  :value="provider"
                >
                </el-option>
              </el-select>
              <label
                v-show="errors.has('new-inventory.provider')"
                class="error"
              >
                {{ errors.first("new-inventory.provider") }}
              </label>
            </div>
          </div>

          <!-- end col two -->
          <div class="col-md-3">
            <div class="form-group">
              <label>Moneda</label>
              <el-select
                placeholder=""
                no-data-text="No hay datos."
                no-match-text="No hay resultados."
                v-model="doc.currency"
                value-key="id"
                name="currency"
                v-validate="'required'"
                filterable
                class="form-control"
                @change="changeCurrency"
              >
                <el-option
                  v-for="currency in currencies"
                  :key="currency.id"
                  :label="currency.name"
                  :value="currency"
                >
                </el-option>
              </el-select>
              <label
                v-show="errors.has('new-inventory.currency')"
                class="error"
              >
                {{ errors.first("new-inventory.currency") }}
              </label>
            </div>
          </div>
          <!-- end col three -->
          <div class="col-md-3">
            <div class="form-group">
              <label class="m-0"># Factura</label>
              <vs-input
                name="invoice_number"
                v-model="doc.invoice_number"
                style="width:400px"
                class="form-control"
                v-validate="'required'"
                data-vv-as="Factura"
              ></vs-input>
              <label
                class="mt-5 pl-5 text-danger"
                v-if="errors.first('new-inventory.invoice_number')"
                >{{ errors.first("new-inventory.invoice_number") }}
              </label>
            </div>
          </div>
          <!-- end col four -->

          <!-- search item bar -->
          <div class="form-group pl-5 pt-3" style="width:80%">
            <label>Buscar</label>
            <el-autocomplete
              value-key="name"
              class="form-control"
              v-model="searchItemPos"
              :fetch-suggestions="querySearch"
              placeholder="Buscar artículo"
              @select="selectItemPos"
            >
              <!-- <vs-table ref="table" :data="item"> -->
              <!-- <template slot="thead">
                    <vs-th>Código interno</vs-th>
                    <vs-th>Referencia</vs-th>
                    <vs-th>SKU</vs-th>
                    <vs-th>Nombre</vs-th>
                    <vs-th>Existencia</vs-th>
                    <vs-th>Precio sin IVA</vs-th>
                    <vs-th>Precio con IVA</vs-th>
                  </template> -->

              <template slot-scope="{ item }">
                <div style="font-size:13px;width: 100%" class="rTable">
                  <div
                    v-if="firstItem == item.id"
                    class="rTableRow"
                    style="width: 100%;"
                  >
                    <div class="rTableHead" style="width: 10%">
                      Código interno
                    </div>
                    <div class="rTableHead" style="width: 10%">Referencia</div>
                    <div class="rTableHead" style="width: 20%">SKU</div>
                    <div class="rTableHead" style="width: 30%">Nombre</div>
                    <div class="rTableHead" style="width: 10%">
                      Existencia
                    </div>
                    <div class="rTableHead" style="width: 10%">
                      Precio sin IVA
                    </div>
                    <div class="rTableHead" style="width: 10%">
                      Precio con IVA
                    </div>
                  </div>
                  <div class="rTableRow" style="width: 100%">
                    <div class="rTableCell" style="height: 40px;width: 10%">
                      {{ item.code }}
                    </div>
                    <div class="rTableCell" style="height: 40px;width: 10%">
                      {{ item.reference }}
                    </div>
                    <div class="rTableCell" style="height: 40px;width: 20%">
                      {{ item.sku }}
                    </div>
                    <div class="rTableCell" style="height: 40px;width: 30%">
                      {{ item.name }}
                    </div>
                    <div class="rTableCell" style="height: 40px;width: 10%">
                      {{ item.inventory ? item.inventory.quantity : "" }}
                    </div>
                    <div class="rTableCell" style="height: 40px;width: 10%">
                      {{ item.price }}
                    </div>
                    <div class="rTableCell" style="height: 40px;width: 10%">
                      {{
                        parseFloat(
                          parseFloat(item.price) +
                            (parseFloat(item.price) *
                              parseFloat(item.tax_type.rate)) /
                              parseFloat(100)
                        ).toFixed(2)
                      }}
                    </div>
                  </div>
                </div>
                <!--<table class="w-100">
                    <thead>
                      <tr>
                      <th>
                        <span v-if="firstItem == item.id">Código interno</span>
                        <div class="w-100">{{ item.code }}</div>
                      </th>
                      <th>
                        <span v-if="firstItem == item.id">Referencia</span>
                        <div :class="`w-100 ${firstItem !== item.id ? 'text-right' : ''}`">{{ item.reference || 's/e' }}</div>
                      </th>
                      <th>
                        <span v-if="firstItem == item.id">SKU</span>
                        <div :class="`w-100 ${firstItem !== item.id ? 'text-right' : ''}`">{{ item.sku }}</div>
                      </th>
                      <th>
                        <span v-if="firstItem == item.id">Nombre</span>
                        <div :class="`w-100 ${firstItem !== item.id ? 'text-center' : ''}`">{{ item.name }}</div>
                      </th>
                      <th>
                        <span v-if="firstItem == item.id">Existencia</span>
                        <div :class="`w-100 ${firstItem !== item.id ? 'text-left' : ''}`">
                          {{ item.inventory ? item.inventory.quantity : "" }}
                        </div>
                      </th>
                      <th>
                        <span v-if="firstItem == item.id">Precio sin IVA</span>
                        <div :class="`w-100 ${firstItem !== item.id ? 'text-right' : ''}`">{{ item.price }}</div>
                      </th>
                      <th>
                        <span v-if="firstItem == item.id">Precio con IVA</span>
                        <div :class="`w-100 ${firstItem !== item.id ? 'text-right' : ''}`">
                          {{ parseFloat((parseFloat(item.price) + (parseFloat(item.price) * parseFloat(item.tax_type.rate) / parseFloat(100)))).toFixed(2) }}
                        </div>
                      </th>
                      </tr>
                    </thead>
                    </table>
                    <table class="w-100">
                      <thead>
                      <th style="text-align:center;width:50px">{{ item.code }}</th>
                      <th style="text-align:center;width:50px">{{ '0003467' }}</th>
                      <th style="text-align:center;width:50px">{{ '236598' }}</th>
                      <th style="text-align:center">{{ item.name }}</th>
                      <th style="text-align:center">{{ item.inventory ? item.inventory.quantity : "" }}</th>
                      <th style="text-align:center">{{ item.price }}</th>
                      <th style="text-align:center">{{ parseFloat((parseFloat(item.price) + (parseFloat(item.price) * parseFloat(item.tax_type.rate) / parseFloat(100)))).toFixed(2) }}</th>
                    </thead>
                    </table>
                     <table>
                    <tbody>
                      <tr :data="item" :key="indextr" v-for="(item, indextr) in data">
                      <tr>
                        <td style="width: 10%">
                          {{ item.code }}
                        </td>
                        <td style="width: 10%">
                          {{ item.reference }}
                        </td>
                        <td style="width: 10%">
                          {{ item.sku }}
                        </td>
                        <td style="width: 25%">
                          {{ item.name }}
                        </td>
                        <td style="width: 15%">
                          {{ item.inventory ? item.inventory.quantity : "" }}
                        </td>
                        <td style="width: 15%">
                          {{ item.price }}
                        </td>
                        <td style="width: 15%">
                          {{ parseFloat((parseFloat(item.price) + (parseFloat(item.price) * parseFloat(item.tax_type.rate) / parseFloat(100)))).toFixed(2) }}
                        </td>
                      </tr>
                    </tbody>
                    </table> -->
              </template>
              <!-- </vs-table> -->
            </el-autocomplete>
          </div>

          <slot name="other-fields"></slot>
        </div>
        <!-- end row one-->

        <div class="row">
          <div style="width:100%" class="table-responsive-sm">
            <!--<table class="table table-striped">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Cantidad</th>
                  <th style="width:150px">
                    Tarifa({{ selected_currency.symbol }})
                  </th>
                  <th style="width: 30px">DTO.(%)</th>
                  <th style="width: 90px">IVA (%)</th>
                  <th style="width:100px">Total</th>
                </tr>
              </thead>
              <tbody>
                <row-item-document
                  v-for="(item, index) in selected_items"
                  :key="item.uid"
                  :items="items"
                  :index="index"
                  :item="item"
                  :selected_currency="selected_currency"
                >
                </row-item-document>
              </tbody>
            </table>-->

            <div class="rTable">
              <div class="rTableRow">
                <div class="rTableHead table_code">Código</div>

                <div class="rTableHead table_name">Nombre</div>
                <div class="rTableHead table_inventory_quantity">
                  Existencia
                </div>
                <div class="rTableHead table_quantity">Cantidad</div>
                <div class="rTableHead table_cost_price">Costo</div>
                <div class="rTableHead table_discount">DTO.(%)</div>
                <div class="rTableHead table_tax">IVA (%)</div>
                <div class="rTableHead table_total">Total Costo</div>
              </div>

              <row-item-inventory
                v-for="(item, index) in selected_items"
                :key="item.uid"
                :items="items"
                :index="index"
                :item="item"
                :selected_currency="selected_currency"
              >
              </row-item-inventory>
            </div>

            <!-- end table -->
          </div>
          <div class="col-md-12 mb-5">
            <a
              href="#"
              @click.prevent="addNewItem()"
              class="btn btn-link text-success font-weight-bold"
              style="font-size: 16px"
            >
              <i class="fa fa-plus-circle"></i>
              Nuevo Item
            </a>
          </div>
        </div>
        <!-- end row -->

        <!-- totales items -->
        <div class="row row-subtotales">
          <div class="col-md-8">
            <div class="form-group"></div>
            <div class="form-group"></div>
          </div>
          <div class="col-md-4 subtotales">
            <div>
              <b>Subtotal:</b>
              {{
                subtotal_inventory
                  | currency({
                    symbol: selected_currency.symbol,
                    fractionCount: 5
                  })
              }}
            </div>
            <div>
              <b>Descuento:</b>
              {{
                discount_inventory
                  | currency({
                    symbol: selected_currency.symbol,
                    fractionCount: 5
                  })
              }}
            </div>
            <div>
              <b>IVA:</b>
              {{
                tax_inventory
                  | currency({
                    symbol: selected_currency.symbol,
                    fractionCount: 5
                  })
              }}
            </div>

            <div>
              <b>Total:</b>
              {{
                total_inventory
                  | currency({
                    symbol: selected_currency.symbol,
                    fractionCount: 5
                  })
              }}
            </div>
          </div>
        </div>
        <!-- end totales items -->

        <!-- other other-fields slot -->
        <slot name="other-fields" :doc="$data.doc.correo"></slot>
        <!-- end other other-fields slot -->

        <div class="col-md-12 text-center p-t-20">
          <vs-button
            type="gradient"
            button="submit"
            color="success"
            :disabled="button_disabled"
          >
            <i class="fa fa-save"></i>
            Guardar
          </vs-button>

          <!-- other buttons slot -->
          <slot name="buttons"></slot>
          <!-- end other buttons slot -->
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import RowItemInventory from "@/components/RowItemInventory.vue";
import inventoriesService from "@/services/inventories.service";
import { mapGetters, mapState, mapActions } from "vuex";
import CalcPrice from "@/components/CalcPrice.vue";
import moment from "moment";

export default {
  name: "add-items-inventory",
  props: {
    items: {
      required: true,
      default: []
    },
    type: {
      required: true,
      default: null
    },
    document: {
      required: false,
      default: false
    },
    preselect_client: {
      required: false
    },
    is_simple: {
      required: false,
      default: false
    },
    is_recurring: {
      required: false,
      default: false
    }
  },
  components: {
    RowItemInventory,
    CalcPrice
  },
  data() {
    return {
      providers: [],
      todoCount: 2,
      doc: {
        //Reference info
        have_reference: false,
        reference_document_type: "",
        reference_code: "",
        reference_number: "",
        reference_date: "",
        reference_reason: "",
        remember_payment: false,
        provider: "",
        invoice_number: "",
        subtotal: 0,
        discount: 0,
        tax: 0,
        total: 0,
        payment_method: {
          id: 1,
          name: "Contado"
        },
        payment_term: "",
        payment_form: {
          id: 1,
          name: "Efectivo"
        },
        currency: {
          id: 2,
          name: "Colones",
          symbol: "¢"
        },
        client: "",
        note: "",
        send_email: false,
        term: "",
        recurring_start_day: moment().format("YYYY-MM-DD"),
        recurring_type: {
          id: 1,
          name: "dias",
          value: "day"
        },
        common_cycle: "",
        recurring_cycle: 1,
        contacts: []
      },
      item: {
        provider: "",
        invoice: ""
      },
      loading: false,
      button_disabled: false,
      firstItem: "",
      searchItemPos: "",
      datePickerOptions: {
        disabledDate(date) {
          var dateObj = new Date();
          var month = dateObj.getUTCMonth() + 1; //months from 1-12
          var day = dateObj.getUTCDate();
          var year = dateObj.getUTCFullYear();

          let newDate = year + "-" + month + "-" + day;
          let current_date = new Date(newDate);
          return date < current_date;
        }
      }
    };
  },
  computed: {
    selected_currency() {
      if (this.doc.currency) {
        return this.doc.currency;
      }
      return this.current_currency;
    },
    ...mapState([
      "currencies",
      "current_currency",
      "selected_items",
      "exchange_rate",
      "company_default",
      "general_configurations"
    ]),
    ...mapGetters([
      "subtotal_inventory",
      "tax_inventory",
      "discount_inventory",
      "total_inventory"
    ])
  },
  methods: {
    querySearch(val, cb) {
      //let val = this.searchItemPos;
      let items = this.items;
      items = items.filter(item => {
        return item.currency_id == this.selected_currency.id;
      });
      if (val !== "") {
        items = items.filter(item => {
          return (
            item.name.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            item.code.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
            item.barcode == val
          );
        });
        this.firstItem = items[0].id;
      } else {
        this.firstItem = items[0].id;
        items = items;
      }
      cb(items);
    },
    async selectItemPos(item) {
      // console.log(item);
      item = JSON.parse(JSON.stringify(item));
      if (item.cabys_code) {
        item.cabys_code = item.cabys_code.id
          ? item.cabys_code.code
          : item.cabys_code;
      }
      item.inventory_quantity = item.inventory ? item.inventory.quantity : "";
      // console.log(item);

      this.searchItemPos = "";
      item.calculate_price = this.calculated_price(
        item.cost_price,
        item.currency,
        this.exchange_rate
      );
      item.quantity = 1;
      item.discount = 0;
      item.percent = true;

      // console.log(item.max_quantity, item.id)
      //if (this.type === "invoice" || this.type === "nd") {
      // inventoriesService.getInventory(item.id).then(inv => {
      //     if (inv.data.item != null){
      //         item.max_quantity = inv.data.item.quantity
      //         item.type = this.type;
      //         console.log(item.max_quantity)
      //     }
      //   }).catch(error1 => {
      //   });
      //}
      const { data: res } = await inventoriesService.getInventory(item.id);
      // console.log(res);
      if (res.item != null) {
        item.max_quantity = res.item.quantity;
        item.type = this.type;
        // console.log(item.max_quantity)
      }

      let selected_items = JSON.parse(JSON.stringify(this.selected_items));
      let exist_item = selected_items.find(i => i.id === item.id);

      if (exist_item) {
        // console.log(exist_item.quantity)
        if (exist_item.quantity < item.max_quantity) {
          exist_item.quantity = exist_item.quantity + 1;
        }
        // console.log(exist_item.quantity)
        let exist_item_index = selected_items.indexOf(exist_item);
        this.$store.dispatch("updateItems", {
          item: exist_item,
          index: exist_item_index
        });
      } else {
        // console.log(selected_items[0])
        if (selected_items[0].id === 0 && selected_items[0].price == 0) {
          selected_items[0].max_quantity = item.max_quantity;
          let empty_item_index = selected_items.indexOf(selected_items[0]);
          this.$store.dispatch("updateItems", {
            item: item,
            index: empty_item_index
          });
        } else {
          this.$store.dispatch("addNewItem", { item: item });
        }
      }
    },
    addNewItem() {
      let item = {
        uid: this.todoCount++,
        id: 0,
        name: "",
        price: 0,
        calculate_price: 0,
        quantity: 1,
        discount: 0,
        inventory: "",
        inventory_quantity: "",
        cost_price: 0,
        percent: true,
        tax_type: {
          id: 1,
          rate: 0
        },
        currency: {
          id: 2,
          symbol: "₡"
        },
        max_quantity: 100000,
        type: ""
      };
      this.$store.dispatch("addNewItem", { item: item });
    },
    calculated_price(price, currency, exchange_rate) {
      let value = 0;
      exchange_rate = parseFloat(exchange_rate);
      price = parseFloat(price);

      if (currency.id === this.selected_currency.id) {
        return price;
      }
      if (this.selected_currency.id === 1) {
        value = price / exchange_rate;
      } else if (this.selected_currency.id === 2) {
        value = price * exchange_rate;
      }
      return parseFloat(value).toFixed(2);
    },
    store(scope, payload = {}) {
      if (this.selected_items.length === 0) {
        this.$message({
          showClose: true,
          message: "El inventario debe contener minimo un artículo.",
          type: "warning"
        });
      }

      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.button_disabled = true;
          this.loading = true;

          this.doc.items = this.selected_items;
          this.doc.subtotal = this.subtotal_inventory;
          this.doc.tax = this.tax_inventory;
          this.doc.discount = this.discount_inventory;
          this.doc.total = this.total_inventory;

          inventoriesService
            .storeInventory(this.doc)
            .then(res => {
              this.loading = false;
              if (res.data.success) {
                this.$message({
                  showClose: true,
                  message: "Inventario guardado con exito",
                  type: "success"
                });
                this.$router.push({
                  name: "item-products"
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: "error"
                });
              }
              this.button_disabled = false;
            })
            .catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: "error"
              });
              this.button_disabled = false;
              this.loading = false;
            });
        }
      });
    },
    changeCurrency() {},
    compareData(data) {
      let selected_items = [];
      data.transaction_details.forEach(i => {
        i.uid = this.todoCount++;
        i.calculate_price = this.calculated_price(
          i.cost_price,
          this.document_data.currency,
          this.document_data.exchange_rate
        );
        i.currency = this.document_data.currency;
        selected_items.push(i);
      });
      this.$store.dispatch("clearItemsInvoice", {});
      this.$store.dispatch("loadItems", { selected_items: selected_items });
    },
    async getProviders(page = 0, search = {}) {
      try {
        const res = await inventoriesService.getProviders(page, search);
        this.providers = res.data;
        // console.log(res.data)
      } catch (error) {
        // console.log(error)
      }
    }
  },
  watch: {
    document_data(new_data) {
      setTimeout(() => {
        if (new_data.document_student) {
          new_data.client = new_data.document_student.student;
        }

        if (this.is_recurring && this.type === "edit-recurring") {
          let recurring_type = this.recurring_types.find(
            i => i.value === new_data.recurring_type
          );
          let common_cycle = this.common_cycles.find(
            i => i.id === new_data.common_cycle
          );

          new_data.common_cycle = common_cycle;
          new_data.recurring_type = recurring_type;
        }
        //If have reference document
        if (
          (new_data.have_reference && this.type !== "nc") ||
          this.type !== "nd"
        ) {
          let reference_document_type = this.reference_document_types.find(
            i => i.id === new_data.reference_document_type_id
          );
          let reference_code = this.reference_codes.find(
            i => i.id === new_data.reference_code_id
          );

          new_data.reference_document_type = reference_document_type;
          new_data.reference_code = reference_code;
        }

        if (this.type === "nc" || this.type === "nd") {
          new_data.have_reference = true;
          new_data.reference_number = new_data.key50digits;
          new_data.reference_date = new_data.created_at;

          let reference_code = this.reference_codes.find(i => i.id === 1);

          let reference_document_type = null;
          if (new_data.document_type === "invoice") {
            reference_document_type = this.reference_document_types.find(
              i => i.id === 1
            );
          }
          if (new_data.document_type === "ticket") {
            reference_document_type = this.reference_document_types.find(
              i => i.id === 4
            );
          }
          new_data.reference_document_type = reference_document_type;
          new_data.reference_code = reference_code;
          new_data.reference_reason = "";
          // console.log(new_data);
        }

        this.doc = Object.assign({}, this.doc, new_data);
        this.doc.note = new_data.comment;
        this.compareData(new_data);
      }, 500);
    },
    "doc.client": function(newVal) {
      this.doc.contacts = [];
      if (this.doc.client && !this.doc.client.generic) {
        this.doc.contacts.push(newVal.email);
        if (newVal.contacts && newVal.contacts.length > 0) {
          newVal.contacts.forEach(i => {
            this.doc.contacts.push(i.email);
          });
        }
      }
    },
    "items": function(newVal) {
      this.firstItem = newVal[0].id;
    }
  },
  mounted() {
    this.getProviders();
  },
  beforeDestroy() {
    this.$store.dispatch("clearItemsInvoice", {});
  }
};
</script>

<style scoped>
.row-subtotales {
  font-display: flex;
  align-items: end;
}

.row-subtotales .subtotales div {
  padding: 0.5em;
  border-bottom: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
}
table thead {
  position: relative;
}
table thead {
  position: relative;
  background-color: #5a5a5a;
  font-weight: bold;
  color: white !important;
}

table tbody tr:hover {
  background-color: rgb(223, 222, 222);
  color: black;
}

.mr-15 {
  margin-right: 10%;
}
</style>
